import { closeLocationSelector, locationSelector$ } from '../../utils/location';
import { CurrentLocationStatus, LocationSelector } from '../../types/location';
import { currentLocationStatus } from '../../constants/error';
import { FormattedMessage } from 'react-intl';
import { LocationHelperTexts } from '../../types/autocomplete';
import { LocationSelectError } from '../location-select-error/LocationSelectError';
import { useEffect, useState } from 'react';
import {
  Root,
  Modal,
  ModalContent,
  LocationAutocomplete,
  SearchIcon,
  CurrentLocation,
  HelperText,
  LocationLabel,
  CloseButton,
  CloseIcon,
} from './LocationModalStyle';

function LocationModal() {
  const [open, setOpen] = useState<boolean>(false);

  const helperText: LocationHelperTexts = {
    default: {
      element: (
        <HelperText>
          <FormattedMessage id='generic.locationHelperTexts.default' />
        </HelperText>
      ),
    },
    invalidInput: {
      element: (
        <HelperText hasError>
          <FormattedMessage id='generic.locationHelperTexts.invalidLocation' />
        </HelperText>
      ),
      position: 'absolute',
    },
  };

  useEffect(() => {
    const subscription = locationSelector$.subscribe((e) => {
      setOpen(e === LocationSelector.MODAL ? true : false);
    });
    return () => subscription.unsubscribe();
  }, []);

  useEffect(() => {
    // Resets the current location status on the closing of the component
    return function reset() {
      currentLocationStatus.next(CurrentLocationStatus.NONE);
    };
  }, []);

  return (
    <Root>
      <Modal
        open={open}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <ModalContent>
          <CloseButton onClick={closeLocationSelector}>
            <CloseIcon></CloseIcon>
          </CloseButton>
          <LocationLabel>Where is your jobsite?</LocationLabel>
          <LocationAutocomplete
            resetCurrentLocationOnClickAway={false}
            hideStartIcon={true}
            endIcon={<SearchIcon />}
            popupPosition='relative'
            helperText={helperText}
          />
          <LocationSelectError />
          <CurrentLocation />
        </ModalContent>
      </Modal>
    </Root>
  );
}

export default LocationModal;
